// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"721":"fd8be391","787":"8ae1ae3f"}[chunkId] + ".chunk.js";
};